import config from '../config';
import * as Constant from '../constants/actionTypes';

export default function(url, options) {
  return Promise.race([
    fetch(url, options),
    new Promise((_, reject) =>
      setTimeout(
        () => reject(new Error(Constant.LOGIN_TIME_OUT)),
        config.requestTimeOut
          ? parseInt(config.requestTimeOut, Constant.TEN)
          : Constant.THREE_SEC_TIME_OUT,
      ),
    ),
  ]);
}
